/**
 * Carrusel de arrastre.
 *
 * No reemplaza el scroll: lo conduce. La tira sigue siendo un contenedor con
 * desbordamiento y anclaje, asi que se arrastra con el dedo, con la rueda y con
 * el teclado aunque este JavaScript no cargue. Lo que agrega son las flechas y
 * el apagado de la que ya no lleva a ningun lado.
 */
class RitSlider extends HTMLElement {
  #pista = null;
  #anterior = null;
  #siguiente = null;

  connectedCallback() {
    this.#pista = this.querySelector('[data-slider-track]');
    this.#anterior = this.querySelector('[data-slider-prev]');
    this.#siguiente = this.querySelector('[data-slider-next]');
    if (!this.#pista) return;

    this.#anterior?.addEventListener('click', () => this.#mover(-1));
    this.#siguiente?.addEventListener('click', () => this.#mover(1));
    this.#pista.addEventListener('scroll', this.#actualizar, { passive: true });
    window.addEventListener('resize', this.#actualizar);

    this.#actualizar();
  }

  disconnectedCallback() {
    this.#pista?.removeEventListener('scroll', this.#actualizar);
    window.removeEventListener('resize', this.#actualizar);
  }

  get #paso() {
    const primera = this.#pista.firstElementChild;
    if (!primera) return this.#pista.clientWidth;

    const separacion = parseFloat(getComputedStyle(this.#pista).columnGap) || 0;
    return primera.getBoundingClientRect().width + separacion;
  }

  #mover(sentido) {
    const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.#pista.scrollBy({ left: this.#paso * sentido, behavior: reducido ? 'auto' : 'smooth' });
  }

  #actualizar = () => {
    const { scrollLeft, scrollWidth, clientWidth } = this.#pista;
    const margen = 4;
    const desbordado = scrollWidth - clientWidth > margen;

    this.dataset.overflow = desbordado ? 'true' : 'false';
    if (this.#anterior) this.#anterior.disabled = scrollLeft <= margen;
    if (this.#siguiente) this.#siguiente.disabled = scrollLeft >= scrollWidth - clientWidth - margen;
  };
}

if (!customElements.get('rit-slider')) customElements.define('rit-slider', RitSlider);
